var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangeDataIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9688 12.9375C31.1406 11.7656 33.0625 11.7656 34.2344 12.9375L36.0625 14.7656C37.2344 15.9375 37.2344 17.8594 36.0625 19.0312L33.8125 21.2812L27.7188 15.1875L29.9688 12.9375ZM32.7344 22.3594L21.8125 33.2812C21.3438 33.75 20.7344 34.125 20.0781 34.3125L14.4062 35.9531C14.0312 36.0938 13.6094 36 13.3281 35.6719C13 35.3906 12.9062 34.9688 13 34.5938L14.6875 28.9219C14.875 28.2656 15.25 27.6562 15.7188 27.1875L26.6406 16.2656L32.7344 22.3594Z",
    fill: "#188AEC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeDataIcon);
export default __webpack_public_path__ + "static/media/changeDataIcon.f00f575065b6456d6ec9cc2d72a1c27e.svg";
export { ForwardRef as ReactComponent };